const DEFAULT_API_BASE =
  process.env.REACT_APP_WP_API_BASE || "http://127.0.0.1:8080/wp-json";

const STORAGE_KEY = "instantors_admin_connection";

export function getStoredConnection() {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    return value ? JSON.parse(value) : null;
  } catch (error) {
    return null;
  }
}

export function saveConnection(connection) {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(connection));
}

export function clearConnection() {
  window.localStorage.removeItem(STORAGE_KEY);
}

export function buildAuthHeader(connection) {
  if (!connection?.username || !connection?.applicationPassword) {
    return {};
  }

  const token = window.btoa(
    `${connection.username}:${connection.applicationPassword.replace(/\s/g, "")}`
  );

  return {
    Authorization: `Basic ${token}`,
  };
}

export async function fetchInstantorsContent(connection, locale = "en") {
  const apiBase = connection?.apiBase || DEFAULT_API_BASE;
  const response = await fetch(
    `${apiBase}/instantors/v1/content?lang=${encodeURIComponent(locale)}`
  );

  if (!response.ok) {
    throw new Error("Unable to load WordPress content.");
  }

  return response.json();
}

export async function saveSiteContent(connection, siteContent) {
  const apiBase = connection?.apiBase || DEFAULT_API_BASE;
  const response = await fetch(`${apiBase}/instantors/v1/site-content`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...buildAuthHeader(connection),
    },
    body: JSON.stringify({ site: siteContent }),
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.message || "Unable to save WordPress content.");
  }

  return response.json();
}

export async function saveContentItem(connection, type, item) {
  const apiBase = connection?.apiBase || DEFAULT_API_BASE;
  const response = await fetch(`${apiBase}/instantors/v1/items/${encodeURIComponent(type)}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...buildAuthHeader(connection),
    },
    body: JSON.stringify(item),
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.message || "Unable to save content item.");
  }

  return response.json();
}

export async function deleteContentItem(connection, type, id) {
  const apiBase = connection?.apiBase || DEFAULT_API_BASE;
  const response = await fetch(
    `${apiBase}/instantors/v1/items/${encodeURIComponent(type)}/${encodeURIComponent(id)}`,
    {
      method: "DELETE",
      headers: buildAuthHeader(connection),
    }
  );

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.message || "Unable to delete content item.");
  }

  return response.json();
}

export { DEFAULT_API_BASE };
